/* * Global configuration for axios * */
import axios from 'axios';
import authService from '../authentication/AuthorizeService';
import config from './Config';
import requestHandler from './apiRequestConfigHandler';
import { successResponseHandler, errorResponseHandler } from './apiResponseHandler';

const configureServices = () => {
  // Set the base url for api calls
  axios.defaults.baseURL = `${config.domain}Services/`;

  // Request interceptor
  axios.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => {
      throw error;
    }
  );

  // Response interceptor
  axios.interceptors.response.use(
    (response) => successResponseHandler(response),
    (error) => errorResponseHandler(error)
  );
};

// Gets the api request configuration
const getConfig = async () => {
  const accessToken = await authService.getAccessToken();
  const conf = {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return conf;
};

const getLMConfig = async () => {
  const baseConfig = await getConfig();
  const conf = {
    baseURL: `${config.domain}learning/service/webapi/`,
    ...baseConfig
  };
  return conf;
};

const getUserSummaryConfig = async () => {
  const baseConfig = await getConfig();
  // Set the usersummary (micro service) url for api calls
  const conf = {
    baseURL: `${config.domain}usersummary/`,
    ...baseConfig
  };
  return conf;
};

const getCoreConfig = async () => {
  const baseConfig = await getConfig();
  // Set the core url for api calls
  const conf = {
    baseURL: `${config.domain}Core/Core/`,
    ...baseConfig
  };
  return conf;
};

const getAssignmentConfig = async () => {
  const baseConfig = await getConfig();
  const conf = {
    baseURL: `${config.domain}assignments/`,
    ...baseConfig
  };
  return conf;
};

const getViltConfig = async () => {
  const baseConfig = await getConfig();
  const conf = {
    baseURL: `${config.domain}vilt/`,
    ...baseConfig
  };
  return conf;
};
const getCMSConfig = async () => {
  const baseConfig = await getConfig();
  const conf = {
    baseURL: `${config.domain}contentmgmt/`,
    ...baseConfig
  };
  return conf;
};

const getVivaConfig = async () => {
  const baseConfig = await getConfig();
  const conf = {
    baseURL: `${config.domain}contentconnectors/api/v1/tenant/`,
    ...baseConfig
  };
  return conf;
};
const getPlatformConfig = async () => {
  const baseConfig = await getConfig();
  const conf = {
    baseURL: `${config.domain}platform/`,
    ...baseConfig
  };
  return conf;
};

const getSkillsConfig = async () => {
  const baseConfig = await getConfig();
  const conf = {
    baseURL: `${config.domain}SkillsConnector/api/v1/jobs/`,
    ...baseConfig
  };
  return conf;
};

const getReportConfig = async () => {
  const baseConfig = await getConfig();
  const conf = {
    baseURL: `${config.domain}core/Reporting/`,
    ...baseConfig
  };
  return conf;
};

const getNotificationConfig = async () => {
  const baseConfig = await getConfig();
  const conf = {
    baseURL: `${config.domain}notificationapi/`,
    ...baseConfig
  };
  return conf;
};

const getDLQConfig = async () => {
  const baseConfig = await getConfig();
  const conf = {
    baseURL: `${config.domain}deadletterqueue/`,
    ...baseConfig
  };
  return conf;
};

export {
  configureServices,
  getConfig,
  getLMConfig,
  getUserSummaryConfig,
  getAssignmentConfig,
  getViltConfig,
  getCMSConfig,
  getVivaConfig,
  getPlatformConfig,
  getSkillsConfig,
  getReportConfig,
  getCoreConfig,
  getNotificationConfig,
  getDLQConfig
};
